import $ from 'jquery';

// Foundation
import { Foundation } from 'foundation-sites/js/foundation.core.js'
Foundation.addToJquery($);

import { Triggers } from 'foundation-sites/js/foundation.util.triggers.js'
Triggers.init($, Foundation);

import { DropdownMenu } from 'foundation-sites/js/foundation.dropdownMenu.js'
Foundation.plugin(DropdownMenu, 'DropdownMenu');

import { Reveal } from 'foundation-sites/js/foundation.reveal.js'
Foundation.plugin(Reveal, 'Reveal');

import { Accordion } from 'foundation-sites/js/foundation.accordion.js'
Foundation.plugin(Accordion, 'Accordion');

import { Equalizer } from 'foundation-sites/js/foundation.equalizer.js'
Foundation.plugin(Equalizer, 'Equalizer');

import { Tabs } from 'foundation-sites/js/foundation.tabs.js'
Foundation.plugin(Tabs, 'Tabs');

import { Toggler } from 'foundation-sites/js/foundation.toggler.js'
Foundation.plugin(Toggler, 'Toggler');

// import { Sticky } from 'foundation-sites/js/foundation.sticky.js'
// Foundation.plugin(Sticky, 'Sticky');

import { SmoothScroll } from 'foundation-sites/js/foundation.smoothScroll.js'
Foundation.plugin(SmoothScroll, 'SmoothScroll');

import Flickity from 'flickity'; 
import 'flickity-fade';
// import 'flickity-imagesloaded';





$(document).foundation();

// Exclude hidden mobile navigation and search modal from tab navigation
function updateTabIndexForHiddenElements() {
  // Mobile navigation (#mobilenavigation) - exclude from tab when not expanded
  // Only target elements inside #mobilenavigation, never desktop nav
  const mobileNav = document.getElementById('mobilenavigation');
  if (mobileNav) {
    const isExpanded = mobileNav.classList.contains('expanded');
    // querySelectorAll on mobileNav already ensures we only get elements inside it
    const focusableElements = mobileNav.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
    focusableElements.forEach(function(el) {
      // Double-check: ensure element is actually inside mobileNav (not desktop nav)
      // Desktop nav has class 'show-for-large', mobile nav doesn't
      const isInDesktopNav = el.closest('.show-for-large') !== null;
      if (!isInDesktopNav) {
        if (isExpanded) {
          // Restore tabindex when expanded
          if (el.hasAttribute('data-original-tabindex')) {
            el.setAttribute('tabindex', el.getAttribute('data-original-tabindex'));
            el.removeAttribute('data-original-tabindex');
          } else if (el.getAttribute('tabindex') === '-1') {
            el.removeAttribute('tabindex');
          }
        } else {
          // Store original tabindex and remove from tab order when hidden
          if (!el.hasAttribute('data-original-tabindex')) {
            const currentTabIndex = el.getAttribute('tabindex');
            if (currentTabIndex !== null) {
              el.setAttribute('data-original-tabindex', currentTabIndex);
            }
          }
          el.setAttribute('tabindex', '-1');
        }
      }
    });
  }
  
  // Search form (#searchform) - exclude from tab when not active
  const searchForm = document.getElementById('searchform');
  if (searchForm) {
    const isActive = searchForm.classList.contains('is-active');
    const focusableElements = searchForm.querySelectorAll('input, button, select, textarea, [tabindex]:not([tabindex="-1"])');
    focusableElements.forEach(function(el) {
      if (isActive) {
        // Restore tabindex when active
        if (el.hasAttribute('data-original-tabindex')) {
          el.setAttribute('tabindex', el.getAttribute('data-original-tabindex'));
          el.removeAttribute('data-original-tabindex');
        } else if (el.getAttribute('tabindex') === '-1') {
          el.removeAttribute('tabindex');
        }
      } else {
        // Store original tabindex and remove from tab order when hidden
        if (!el.hasAttribute('data-original-tabindex')) {
          const currentTabIndex = el.getAttribute('tabindex');
          if (currentTabIndex !== null) {
            el.setAttribute('data-original-tabindex', currentTabIndex);
          }
        }
        el.setAttribute('tabindex', '-1');
      }
    });
  }
}

// Run on page load
$(document).ready(function() {
  updateTabIndexForHiddenElements();
  
  // Watch for changes using MutationObserver for better performance
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        updateTabIndexForHiddenElements();
      }
    });
  });
  
  // Observe mobile navigation only
  const mobileNav = document.getElementById('mobilenavigation');
  if (mobileNav) {
    observer.observe(mobileNav, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
  
  // Observe search form
  const searchForm = document.getElementById('searchform');
  if (searchForm) {
    observer.observe(searchForm, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
  
  // Also listen to Foundation events as backup
  $(document).on('toggle.zf.toggler', function() {
    setTimeout(updateTabIndexForHiddenElements, 100);
  });
});

// Accessibility icon - Toggle freeze/unfreeze Vimeo video and Lottie animations
// Store Vimeo player instance and frozen state
let vimeoPlayer = null;
let isVideoFrozen = false;
let originalVimeoSrc = null;
let lottieStates = new Map(); // Store original states of Lottie players

// Load Vimeo Player API and initialize player
function initVimeoPlayer() {
  const vimeoIframe = document.querySelector('.videoHome');
  if (!vimeoIframe) return;
  
  // Store original src
  originalVimeoSrc = vimeoIframe.src;
  
  // Load Vimeo Player API if not already loaded
  if (typeof Vimeo === 'undefined') {
    const script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.onload = function() {
      createVimeoPlayer(vimeoIframe);
    };
    document.head.appendChild(script);
  } else {
    createVimeoPlayer(vimeoIframe);
  }
}

function createVimeoPlayer(iframe) {
  try {
    vimeoPlayer = new Vimeo.Player(iframe);
    console.log('Vimeo Player API initialized');
  } catch (err) {
    console.error('Failed to initialize Vimeo Player:', err);
  }
}

// Store original Lottie player states
function storeLottieStates() {
  const lottiePlayers = document.querySelectorAll('lottie-player');
  lottiePlayers.forEach(function(player, index) {
    if (!lottieStates.has(index)) {
      lottieStates.set(index, {
        autoplay: player.getAttribute('autoplay'),
        loop: player.getAttribute('loop'),
        pointerEvents: player.style.pointerEvents
      });
    }
  });
}

function freezeCoverHomeSliders() {
  const sliders = document.querySelectorAll('.coverhomeSlider');
  sliders.forEach(function (el) {
    // Make it non-interactive
    el.style.pointerEvents = 'none';

    // Stop Flickity autoplay if Flickity is available + instance exists
    try {
      if (typeof Flickity !== 'undefined' && typeof Flickity.data === 'function') {
        const flkty = Flickity.data(el);
        if (flkty) {
          // Remember if this slider had autoplay enabled
          if (!el.hasAttribute('data-coverhome-autoplay')) {
            const hadAutoplay = !!(flkty.options && flkty.options.autoPlay);
            el.setAttribute('data-coverhome-autoplay', hadAutoplay ? '1' : '0');
          }
          // Remember draggable state so we can restore it
          if (!el.hasAttribute('data-coverhome-draggable')) {
            const wasDraggable = !!(flkty.options && flkty.options.draggable);
            el.setAttribute('data-coverhome-draggable', wasDraggable ? '1' : '0');
          }

          if (typeof flkty.stopPlayer === 'function') flkty.stopPlayer();

          // Freeze: stop user-driven movement while keeping current slide rendered
          if (flkty.options) flkty.options.draggable = false;
          if (typeof flkty.unbindDrag === 'function') flkty.unbindDrag();
        }
      }
    } catch (e) {}
  });
}

function unfreezeCoverHomeSliders() {
  const sliders = document.querySelectorAll('.coverhomeSlider');
  sliders.forEach(function (el) {
    el.style.pointerEvents = '';

    try {
      if (typeof Flickity !== 'undefined' && typeof Flickity.data === 'function') {
        const flkty = Flickity.data(el);
        if (flkty) {
          // Restore draggable state
          const shouldBeDraggable = el.getAttribute('data-coverhome-draggable') === '1';
          if (flkty.options) flkty.options.draggable = shouldBeDraggable;
          if (shouldBeDraggable && typeof flkty.bindDrag === 'function') flkty.bindDrag();

          // Restore autoplay only if it was originally enabled
          const shouldAutoplay = el.getAttribute('data-coverhome-autoplay') === '1';
          if (shouldAutoplay && typeof flkty.playPlayer === 'function') flkty.playPlayer();
        }
      }
    } catch (e) {}
  });
}

// Freeze everything
function freezeAnimations() {
  console.log('Freezing animations');
  
  // Add active class to buttons and enable high-contrast mode on body
  document.querySelectorAll('.accessibility-toggle').forEach(function(btn) {
    btn.classList.add('is-active');
  });
  document.body.classList.add('high-contrast-mode');
  
  // Freeze Vimeo video using Player API
  const vimeoIframe = document.querySelector('.videoHome');
  if (vimeoIframe) {
    if (vimeoPlayer) {
      vimeoPlayer.pause().then(function() {
        console.log('Vimeo video paused');
        vimeoPlayer.setVolume(0).catch(() => {});
      }).catch(function(error) {
        console.error('Error pausing Vimeo:', error);
      });
    } else {
      // Fallback: try postMessage
      vimeoIframe.contentWindow.postMessage('{"method":"pause"}', '*');
    }
    
    // Disable interaction
    vimeoIframe.style.pointerEvents = 'none';
    const currentSrc = vimeoIframe.src;
    const newSrc = currentSrc.replace(/background=1|autoplay=1/g, 'autoplay=0&controls=0');
    if (newSrc !== currentSrc) {
      vimeoIframe.src = newSrc;
    }
  }
  
  // Stop all Lottie animations
  const lottiePlayers = document.querySelectorAll('lottie-player');
  lottiePlayers.forEach(function(player) {
    if (player && typeof player.stop === 'function') {
      player.stop();
    } else if (player && typeof player.pause === 'function') {
      player.pause();
    }
    if (player && typeof player.setAttribute === 'function') {
      player.setAttribute('autoplay', 'false');
      player.setAttribute('loop', 'false');
      player.style.pointerEvents = 'none';
    }
  });

  // Freeze cover home slider autoplay + interaction
  freezeCoverHomeSliders();
  
  isVideoFrozen = true;
  try {
    sessionStorage.setItem('accessibilityHighContrast', '1');
  } catch (e) {}
}

// Unfreeze everything
function unfreezeAnimations() {
  console.log('Unfreezing animations');
  
  // Remove active class from buttons and high-contrast mode from body
  document.querySelectorAll('.accessibility-toggle').forEach(function(btn) {
    btn.classList.remove('is-active');
  });
  document.body.classList.remove('high-contrast-mode');
  
  // Restore Vimeo video
  const vimeoIframe = document.querySelector('.videoHome');
  if (vimeoIframe && originalVimeoSrc) {
    // Restore original src
    vimeoIframe.src = originalVimeoSrc;
    vimeoIframe.style.pointerEvents = 'auto';
    
    if (vimeoPlayer) {
      vimeoPlayer.play().then(function() {
        console.log('Vimeo video playing');
        vimeoPlayer.setVolume(1).catch(() => {});
      }).catch(function(error) {
        console.error('Error playing Vimeo:', error);
      });
    }
  }
  
  // Restore all Lottie animations
  const lottiePlayers = document.querySelectorAll('lottie-player');
  lottiePlayers.forEach(function(player, index) {
    const state = lottieStates.get(index);
    if (state) {
      if (state.autoplay !== null) {
        player.setAttribute('autoplay', state.autoplay);
      }
      if (state.loop !== null) {
        player.setAttribute('loop', state.loop);
      }
      player.style.pointerEvents = state.pointerEvents || 'auto';
    } else {
      // Default restore
      player.setAttribute('autoplay', 'true');
      player.setAttribute('loop', 'true');
      player.style.pointerEvents = 'auto';
    }
    
    // Play the animation
    if (player && typeof player.play === 'function') {
      player.play();
    }
  });

  // Restore cover home slider autoplay + interaction
  unfreezeCoverHomeSliders();
  
  isVideoFrozen = false;
  try {
    sessionStorage.removeItem('accessibilityHighContrast');
  } catch (e) {}
}

// Initialize Vimeo player when DOM is ready
$(document).ready(function() {
  initVimeoPlayer();
  storeLottieStates();
  
  // Restore accessibility state from session (persists across page navigations)
  try {
    if (sessionStorage.getItem('accessibilityHighContrast') === '1') {
      isVideoFrozen = true;
      freezeAnimations();
    }
  } catch (e) {}
  
  document.querySelectorAll('.accessibility-toggle').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (isVideoFrozen) {
        unfreezeAnimations();
      } else {
        freezeAnimations();
      }

      return false;
    }, true); // Use capture phase to fire before Foundation
  });

  // Below 440px: move the header icons into the mobile nav (under the menu links)
  const iconsCell = document.querySelector('header .icons');
  const mobileIconsTarget = document.getElementById('mobileIconsTarget');
  if (iconsCell && mobileIconsTarget) {
    const iconsHome = iconsCell.parentNode;
    const iconsNext = iconsCell.nextElementSibling;
    const iconsQuery = window.matchMedia('(max-width: 440px)');
    function relocateIcons(mq) {
      if (mq.matches) {
        mobileIconsTarget.appendChild(iconsCell);
      } else {
        iconsHome.insertBefore(iconsCell, iconsNext);
      }
    }
    relocateIcons(iconsQuery);
    iconsQuery.addEventListener('change', relocateIcons);
  }
});


var galleryElems = document.querySelectorAll('.mainSlider');
for ( var i=0, len = galleryElems.length; i < len; i++ ) {
  var galleryElem = galleryElems[i];
  new Flickity( galleryElem, {
    //wrapAround: true,
    //prevNextButtons: false,
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    drag: false,
});
}

var galleryElems = document.querySelectorAll('.imageSlider');
for ( var i=0, len = galleryElems.length; i < len; i++ ) {
  var galleryElem = galleryElems[i];
  new Flickity( galleryElem, {
    // imagesLoaded: true,
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    drag: false,
    arrowShape: { 
        x0: 0,
        x1: 50, y1: 40,
        x2: 0, y2: 0,
        x3: 100
      }
  });
}

var galleryElems = document.querySelectorAll('.coverSlider');
for ( var i=0, len = galleryElems.length; i < len; i++ ) {
  var galleryElem = galleryElems[i];
  new Flickity( galleryElem, {
    cellAlign: 'left',
    // contain: true,
    dragThreshold: 100,
    pageDots: false,
    wrapAround: true,
    // draggable: false,
    arrowShape: { 
        x0: 0,
        x1: 50, y1: 40,
        x2: 0, y2: 0,
        x3: 100
      }
  });
}

var galleryElems = document.querySelectorAll('.coverhomeSlider');
for ( var i=0, len = galleryElems.length; i < len; i++ ) {
  var galleryElem = galleryElems[i];
  new Flickity( galleryElem, {
    dragThreshold: 100,
    autoPlay: 2000,
    cellAlign: 'left',
    // contain: true,
    pageDots: false,
    // draggable: false,
    prevNextButtons: false,
    fade: true,
    pauseAutoPlayOnHover: false,
  });
}



var galleryElems = document.querySelectorAll('.itemSlider');
for ( var i=0, len = galleryElems.length; i < len; i++ ) {
  var galleryElem = galleryElems[i];
  new Flickity( galleryElem, {
    groupCells: true,
    cellAlign: 'left',
    contain: true,
    pageDots: true,
    freeScroll: true,
    drag: false,
    arrowShape: { 
        x0: 0,
        x1: 50, y1: 40,
        x2: 0, y2: 0,
        x3: 100
      }
  });
}

var galleryElems = document.querySelectorAll('.soortgelijkSlider');
for ( var i=0, len = galleryElems.length; i < len; i++ ) {
  var galleryElem = galleryElems[i];
  new Flickity( galleryElem, {
    groupCells: true,
    cellAlign: 'left',
    contain: true,
    pageDots: true,
    drag: false,
    arrowShape: { 
        x0: 0,
        x1: 50, y1: 40,
        x2: 0, y2: 0,
        x3: 100
      }
  });
}

var galleryElems = document.querySelectorAll('.hulpbijzoekenSlider');
for ( var i=0, len = galleryElems.length; i < len; i++ ) {
  var galleryElem = galleryElems[i];
  new Flickity( galleryElem, {
    groupCells: true,
    cellAlign: 'left',
    contain: true,
    pageDots: true,
    drag: false,
    arrowShape: { 
        x0: 0,
        x1: 50, y1: 40,
        x2: 0, y2: 0,
        x3: 100
      }
  });
}

var galleryElems = document.querySelectorAll('.socialSlider');
for ( var i=0, len = galleryElems.length; i < len; i++ ) {
  var galleryElem = galleryElems[i];
  new Flickity( galleryElem, {
    groupCells: true,
    cellAlign: 'left',
    contain: true,
    pageDots: true,
    drag: false,
    arrowShape: { 
        x0: 0,
        x1: 50, y1: 40,
        x2: 0, y2: 0,
        x3: 100
      }
  });
}

var galleryElems = document.querySelectorAll('.programma-full-Slider');
for ( var i=0, len = galleryElems.length; i < len; i++ ) {
  var galleryElem = galleryElems[i];
  new Flickity( galleryElem, {
    //wrapAround: true,
    //prevNextButtons: false,
    cellAlign: 'left',
    contain: true,
    drag: false,
    pageDots: true,
    wrapAround: true,
    arrowShape: { 
        x0: 0,
        x1: 50, y1: 40,
        x2: 0, y2: 0,
        x3: 100
      }
  });
}

var galleryElems = document.querySelectorAll('.reviewsSlider');
for ( var i=0, len = galleryElems.length; i < len; i++ ) {
  var galleryElem = galleryElems[i];
  new Flickity( galleryElem, {
    cellAlign: 'left',
    // percentPosition: false,
    contain: true,
    drag: false,
    pageDots: true,
    prevNextButtons: false,
    adaptiveHeight: false,
  });
}


// VIDEO EMBED

document.querySelectorAll(':is(video-embed) button').forEach(button => button.addEventListener('click', () => {
  if(button.parentNode.parentNode) { 
    if(button.parentNode.parentNode.querySelector('.wp-post-image')) {
      button.parentNode.parentNode.querySelector('.wp-post-image').classList.toggle('hide');
    }
  }
    const video = button.previousElementSibling;
    video.src = video.dataset.src;
}));



document.querySelectorAll(':is(video-embed) button.large-video').forEach(button => button.addEventListener('click', () => {
    const video = button.previousElementSibling;
    video.src = video.dataset.src;
}));


// scaleheader

function scaleHeader() {
    var scalable = document.querySelectorAll('.scale');
    var margin = 10;
    for (var i = 0; i < scalable.length; i++) {
      var scalableContainer = scalable[i].parentNode;
      scalable[i].style.transform = 'scale(1)';
      var scalableContainerWidth = scalableContainer.offsetWidth - margin;
      var scalableWidth = scalable[i].offsetWidth;
      scalable[i].style.transform = 'scale(' + scalableContainerWidth / scalableWidth + ')';
      scalableContainer.style.height = scalable[i].getBoundingClientRect().height + 'px';
    }
  } 
  
  
  // Debounce by David Walsch
  // https://davidwalsh.name/javascript-debounce-function
  
  function debounce(func, wait, immediate) {
      var timeout;
      return function() {
          var context = this, args = arguments;
          var later = function() {
              timeout = null;
              if (!immediate) func.apply(context, args);
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
      };
  };
  
  var myScaleFunction = debounce(function() {
      scaleHeader();
  }, 10);
  
  myScaleFunction();
  
  window.addEventListener('resize', myScaleFunction);



  /* STICKYNAV */
$(document).ready(function () {
    'use strict';
     var c, currentScrollTop = 0,
         navbar = $('.stickynav');
         $(window).scroll(function () {
            var a = $(window).scrollTop();
            var b = navbar.height();
            currentScrollTop = a;
            if (c < currentScrollTop && a > b + b) {
              navbar.addClass("scrollUp");
            } else if (c > currentScrollTop && !(a <= b)) {
              navbar.removeClass("scrollUp");
            }
            c = currentScrollTop;
      });
      $(function () {
          $(window).scroll(function () {
              if ($(this).scrollTop() > 100) {
                  $('.stickynav').addClass('scroll');
              } else {
                  $('.stickynav').removeClass('scroll');
              }
          });
      });    
  });

// keypress ESC menu

$(document).ready(function () {
    $(document).keydown(function(e){
  
        if(e.keyCode == 27) {
            if ($('.stickynav').hasClass('expanded')) {
                $('.stickynav').removeClass('expanded');
                $('.menutoggle').removeClass('expanded');
                $('body').removeClass('expanded');
                $('body').removeClass('escape_is_not_an_option');
                $('.mobilenavigation').removeClass('expanded');
             
            } else {
                $('body').addClass('escape_is_not_an_option');
            }
        }
    });
  });
  
  // SELECT FIELD NAVIGATION

  $('#subnav').on('change',function(){
    var $option = $(this).find('option:selected');
    var value = $option.val();

    setTimeout(function(){ 
        $('html, body').animate({
        scrollTop: $("#" + value).offset().top
    }, 1500);
    },250);
    })



    //FACET WP IS NOT YET LOADED

// document.addEventListener('facetwp-loaded', function() {
//     fUtil('.facet-reset').addClass('visible');
// });




// CUSTOM MANDJE CODE

var input = document.getElementById("tmplugin_basket_badge_nbr");
var container = document.getElementById("tmplugin_basket_badge");
var text = input.innerHTML;
if(text == 0){
  container.style.display = "none";
}

// var searchicon = document.getElementById("searchicon");
// searchicon.onclick = function(){

//   document.getElementById("searchformx").focus();
// }

document.getElementById("searchicon").addEventListener("click", () => {
  document.getElementById("searchformx").focus();
});


// Slide in tickets from bottom mobile

window.addEventListener('scroll', function() {
  var container = document.querySelector('.mobileTicketContainer');
  if (!container) { return; }
  var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollPosition > 300) {
      container.style.visibility = 'visible';
      container.style.opacity = 1;
      container.style.transform = 'translateY(0)';
  } else {
      container.style.opacity = 0;
      container.style.transform = 'translateY(100%)';
      container.addEventListener('transitionend', function() {
          if (container.style.opacity == 0) {
              container.style.visibility = 'hidden';
          }
      }, { once: true });
  }
});

// Ticket fast lane popup
(function() {
    var overlay = document.getElementById('fastlane-overlay');
    if (!overlay) return;
    var DISMISS_KEY = 'fastlane_dismissed_until';
    var DISMISS_MS  = 15 * 60 * 1000;
    if (Date.now() < Number(localStorage.getItem(DISMISS_KEY))) { overlay.style.display = 'none'; return; }
    function closePopup() { overlay.style.display = 'none'; }
    function dismissPopup() { localStorage.setItem(DISMISS_KEY, Date.now() + DISMISS_MS); closePopup(); }
    document.getElementById('fastlane-close').addEventListener('click', closePopup);
    document.getElementById('fastlane-dismiss').addEventListener('click', dismissPopup);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) closePopup(); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closePopup(); });
})();
